<p-sidebar
  [visible]="visible"
  (visibleChange)="onSidebarVisibleChange($event)"
  (onHide)="onPrimeSidebarHide()"
  position="right"
  [style]="{ width: '720px' }"
  [modal]="firstAccessModalOverlay"
  [dismissible]="!firstAccessModalOverlay"
  [showCloseIcon]="true"
  [blockScroll]="firstAccessModalOverlay"
  [closeOnEscape]="!firstAccessModalOverlay"
  [appendTo]="'body'"
>
  <ng-template pTemplate="header">
    <afoone-wxrl-form-header
      [title]="'WXRL.SCHEMA.EDIT_HEADER' | translate"
      [activeTab]="'Cabecera'"
    >
    </afoone-wxrl-form-header>
  </ng-template>

  <div *ngIf="headerFormReady" class="drawer-content header-form-grid" [formGroup]="headerForm">
    <label for="ruleNr" class="header-label">ID</label>
    <div class="header-field">
      <p-inputNumber
        id="ruleNr"
        formControlName="ruleNr"
        [showButtons]="isNewRule"
        [min]="1"
        [useGrouping]="false"
        class="w-full"
        [style]="{ width: '100%' }"
        inputStyleClass="w-full"
      ></p-inputNumber>
      <small
        class="p-error"
        *ngIf="
          headerForm.get('ruleNr')?.invalid && headerForm.get('ruleNr')?.touched
        "
      >
        <span *ngIf="headerForm.get('ruleNr')?.errors?.['required']">{{
          'WXRL.HEADER_DRAWER.ERRORS.RULE_NR_REQUIRED' | translate
        }}</span>
        <span *ngIf="headerForm.get('ruleNr')?.errors?.['min']">{{
          'WXRL.HEADER_DRAWER.ERRORS.RULE_NR_MIN' | translate
        }}</span>
        <span *ngIf="headerForm.get('ruleNr')?.errors?.['ruleExists']">{{
          'WXRL.CLONE.ERRORS.NEW_EXISTS' | translate
        }}</span>
      </small>
    </div>

    <label for="ruleKrz" class="header-label">{{ "WXRL.RULE.FORM.ABREVIATURA" | translate }} *</label>
    <div class="header-field">
      <input
        id="ruleKrz"
        type="text"
        pInputText
        formControlName="ruleKrz"
        class="wxrl-rule-krz-input"
        maxlength="10"
      />
      <small
        class="p-error"
        *ngIf="
          headerForm.get('ruleKrz')?.invalid &&
          headerForm.get('ruleKrz')?.touched
        "
      >
        La abreviatura es obligatoria
      </small>
      <small
        class="p-error"
        *ngIf="headerForm.get('ruleKrz')?.errors?.['maxlength'] && headerForm.get('ruleKrz')?.touched"
      >
        Máximo 10 caracteres
      </small>
    </div>

    <label for="ruleName" class="header-label">{{ "WXRL.RULE.DESCRIPCION" | translate }} *</label>
    <div class="header-field">
      <input
        id="ruleName"
        type="text"
        pInputText
        formControlName="ruleName"
        class="w-full"
      />
      <small
        class="p-error"
        *ngIf="
          headerForm.get('ruleName')?.invalid &&
          headerForm.get('ruleName')?.touched
        "
      >
        La descripción es obligatoria
      </small>
    </div>

    <label for="kommentar-header" class="header-label">{{ "WXRL.RULE.FORM.COMENTARIO" | translate }}</label>
      <textarea
        id="kommentar-header"
        pInputTextarea
        formControlName="kommentar"
        rows="3"
      class="w-full header-input"
      ></textarea>

    <label for="condition" class="header-label">{{ "WXRL.RULE.FORM.FORMULA" | translate }}</label>
    <afoone-wxrl-formula-editor
      formControlName="condition"
      [conditions]="conditions"
      [allowUnknownConditionIds]="(conditions?.length ?? 0) === 0"
      [interactionLocked]="headerForm.get('directExecution')?.value === true"
      class="header-input"
    ></afoone-wxrl-formula-editor>

    <span class="header-label"></span>
    <div class="header-field">
      <p-checkbox
        formControlName="negRule"
        inputId="negRule"
        [binary]="true"
      ></p-checkbox>
      <label for="negRule" class="ml-2">{{
        "WXRL.RULE.FORM.NEGADA" | translate
      }}</label>
    </div>

    <span class="header-label"></span>
    <div class="header-field">
      <p-checkbox
        formControlName="directExecution"
        inputId="directExecution"
        [binary]="true"
        [pTooltip]="'WXRL.RULE.FORM.NO_CONDITIONS_RULE_TOOLTIP' | translate"
        tooltipPosition="top"
      ></p-checkbox>
      <label for="directExecution" class="ml-2">{{
        "WXRL.RULE.FORM.NO_CONDITIONS_RULE" | translate
      }}</label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        (click)="onCancel()"
        severity="secondary"
        [text]="true"
      ></p-button>
      <p-button
        label="Guardar"
        icon="pi pi-check"
        (click)="onSave()"
        [disabled]="headerForm.invalid"
      ></p-button>
    </div>
  </ng-template>
</p-sidebar>

